import React from "react";
const ModalHeader = ({ onClose }) => {
  return (
    <div className="modal-header">
      <h1 className="modal-title fs-5" id="exampleModalLabel">
        Add New Workout
      </h1>
      <button
        type="button"
        className="btn-close"
        onClick={onClose}
        aria-label="Close"
      ></button>
    </div>
  );
};
export default ModalHeader;
